import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { useHistory } from 'react-router-dom';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Grid,
    Divider,
    Switch,
    TextField,
    Typography,
    colors,
    Table,
    TableHead,
    TableCell,
    Modal,
    Backdrop,
    TableBody,
    TableRow
} from '@material-ui/core';
import { add_showroom_operator } from '../../api/API';


const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3)
    },

    results: {
        marginTop: theme.spacing(3)
    },

    closeButton: {
        color: theme.palette.white,
        backgroundColor: 'black',
        '&:hover': {
            backgroundColor: "black"
        },

    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },

    flexend: {
        justifyContent: 'flex-end',
    }
}));

export default function CreateShowroomOperator(props) {

    const classes = useStyles();
    const [isOpen, setisOpen] = useState(props.open);

    const [passwordError, setPasswordError] = useState({
        isError: false,
        message: ''
    });

    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [values, setValues] = useState({
        email: '',
        contact: '',
        password: '',
        password2: ''
    });


    useEffect(() => {
        console.log(props);

    });

    const history = useHistory();

    const handleChange = event => {
        event.persist();
        if (event.target.name == "password") {
            checkPassword(event.target.value);
        }
        setValues({
            ...values,
            [event.target.name]:
                event.target.type === 'checkbox'
                    ? event.target.checked
                    : event.target.value
        });
    };
    const checkPassword = (password) => {
        let check_length = new RegExp("(?=.{6,})");
        let check_number = new RegExp("(?=.*[0-9])");
        let check_special = new RegExp("(?:.*[!@#$%^&*()+\'\"]+.*)");

        if (!check_length.test(password)) {
            setPasswordError({
                isError: true,
                message: "Password must be at least 6 characters or longer"
            });
            return false;
        }
        if (!check_number.test(password)) {
            setPasswordError({
                isError: true,
                message: "Password must be at contain at least 1 number"
            });
            return false;
        }
        if (!check_special.test(password)) {
            setPasswordError({
                isError: true,
                message: "Password must be at least 1 special character"
            });
            return false;
        }
        setPasswordError({
            isError: false,
            message: "All Good"
        });

        return true;
    }

    const handleSubmit = async event => {
        event.preventDefault();
        if(!checkPassword(values.password)){
            return;
        }

        if(values.password == ""){
            alert("Password cannot be empty");
            return;
        }
        if(values.password != values.password2){
            alert("Passwords do not match");
            return;
        }
        let response = await add_showroom_operator(values);
        if (response) {
            history.push("/operator");
        }

    };

    const handleOpen = () => {
        setisOpen(true);
    }
    const handleSnackbarClose = () => {
        setOpenSnackbar(false);
    };


    const handleClose = () => {
        history.push("/operator");

    };

 

    return (
        <div className={clsx(classes.root, props.className)} >

            <Card


            >
                <form onSubmit={handleSubmit}>
                    <CardHeader title="Create Operator">

                    </CardHeader>
                    <Divider />
                    <CardContent>
                        <Grid
                            container
                            spacing={4}
                        >

<Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="name"
                                    name="name"
                                    onChange={handleChange}
                                    value={values.name}
                                    variant="outlined"
                                >

                                </TextField>

                            </Grid>
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="email"
                                    name="email"
                                    onChange={handleChange}
                                    value={values.email}
                                    variant="outlined"
                                >

                                </TextField>

                            </Grid>

                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="contact"
                                    name="contact"
                                    onChange={handleChange}
                                    value={values.contact}
                                    variant="outlined"
                                >

                                </TextField>

                            </Grid>
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="password"
                                    name="password"
                                    type="password"
                                    onChange={handleChange}
                                    value={values.password}
                                    variant="outlined"
                                    error={passwordError.isError}
                                    helperText={passwordError.message}
                                >

                                </TextField>

                            </Grid>
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="confirm password"
                                    name="password2"
                                    type="password"
                                    onChange={handleChange}
                                    value={values.password2}
                                    variant="outlined"
                                >

                                </TextField>

                            </Grid>
                        </Grid>
                    </CardContent>
                    <Divider />
                    <CardActions className={classes.flexend}>
                        <Button
                            className={classes.closeButton}
                            type="button"
                            variant="contained"
                            onClick={handleClose}
                        >
                            <CloseIcon className={classes.leftIcon} />
                    Close
            </Button>
                        <Button
                            type="submit"
                            variant="contained"

                        >
                            <SaveIcon className={classes.leftIcon} />
                    Save Changes
            </Button>
                    </CardActions>
                </form>
            </Card>
        </div>

    )
}

